import React from 'react';
import { Box, Typography, Button } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { useProductFormStyles } from './ProductForm.style';
import { ProductFormProps } from './ProductForm.type';
import { ProductBasics } from './ProductBasics';
import { ApplicationType } from './ApplicationType';
import { SubscriptionApprovalType } from './SubscriptionApprovalType';
import { ProductVisibility } from './ProductVisibility';
import { Alert } from '@material-ui/lab';


export const ProductForm: React.FC<ProductFormProps> = ({ handleSubmit, hasError, error, isEditMode = false, onMakePublicConfirm }) => {
  const classes = useProductFormStyles();

  return (
    <Box className={classes.formContent}>
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        {hasError && error && (
          <Box mb={2}>
          <Alert severity="error">
            <Typography color="error" variant="body2">
              {error}
            </Typography>
          </Alert>
          </Box>
        )}
        <ProductBasics />
        <ProductVisibility isEditMode={isEditMode} onMakePublicConfirm={onMakePublicConfirm} />            
        <ApplicationType />
        <SubscriptionApprovalType />
      </form>
    </Box>
  );
};

export default ProductForm;
